import { makeStyles } from "@material-ui/core";
import { TreeItem } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    treeItemLabel: {
        fontWeight: 600,
        color: theme.palette.text.primary,
        backgroundColor: '#ffffff',
        padding: theme.spacing(0.5, 1),
    },
    treeItemContentExpanded: {
        backgroundColor: '#ffffff',
    },
    deleteButton: {
        color: theme.palette.error.light,
        padding: 2,
        '&:hover': {
            color: theme.palette.error.main,
        },
        '&:focus': {
            outline: 'none',
        },
    },
    addClusterlet: {
        '&:focus': {
            outline: 'none',
        },
    },
    smallText: {
        fontSize: '0.8rem',
    },
    eventDescription: {
        fontSize: '0.65rem',
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.3),
    },
    childHandler: {
        fontSize: '0.75rem',
        paddingLeft: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
}));

const StyledTreeItem = (props) => {
    const classes = useStyles();
    return (
        <TreeItem
            {...props}
            classes={{
                label: classes.treeItemLabel,
                content: classes.treeItemContentExpanded,
            }}
        />
    );
};

export default StyledTreeItem;